import { render, staticRenderFns } from "./_destructedAssets.vue?vue&type=template&id=d383e678&scoped=true&"
import script from "./_destructedAssets.vue?vue&type=script&lang=js&"
export * from "./_destructedAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d383e678",
  null
  
)

export default component.exports